import axios from 'axios';
import apiConfig from '../../api.config';

export default function getPaperlessDevices({hotelId}) {
  const {
    host,
    URIs: {getPaperlessDevices},
  } = apiConfig;

  const uri = `${host}${getPaperlessDevices}`.replace(':hotelId', hotelId);

  return axios
    .get(uri)
    .then(res => {
      return res.data;
    });
}
